module.exports = __webpack_public_path__ + "static/media/23.ff6b3dd6.jpg";